<!-- <ngx-ui-loader bgsColor="#0d6efd" overlayColor="rgba(40,40,40,0.3)" bgsOpacity="1" [bgsTemplate]="backgroundSpinner" [fgsTemplate]="foregroundSpinner"></ngx-ui-loader> -->
<app-loading [excludedUrls]="urlsExcluidas"></app-loading>
<!-- <ng-template #backgroundSpinner>
    <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
  </ng-template>
  <ng-template #foregroundSpinner>
    <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
  </ng-template>
<app-status-conexao></app-status-conexao> -->
<app-status-conexao></app-status-conexao>
<router-outlet></router-outlet>
